import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import ServicesModule from '../../api/services/ServicesModule';

const Services = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("")
  const [file, setFile] = useState()
  useEffect(() => {
    if (localStorage.getItem("admintoken")) {

    }
    else {
      navigate('/')
    }

  }, []);

  const onFileChange = (e) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(e.target.files[0])
    fileReader.onload = () => {
      var icon = fileReader.result
      setFile(icon)
    }
  }
  const onSubmitForm = async (event) => {
    event.preventDefault();
    try {
      var userData = {
        "title": event.target.title.value,
        "de_title":event.target.de_title.value,
        "price": event.target.price.value,
        "per_month": event.target.per_month.value,
        "description": event.target.description.value,
        "de_description":event.target.de_description.value,
        "icon": file ? file.split(',')[1] : "",
        "type": event.target.type.value,
      }
      let responseData = await ServicesModule.store(userData).json()
      if (responseData.status === true) {
        navigate("/admin/services");
      }
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };
  return (
    <>
      <MainPagetitle mainTitle="Services" pageTitle={'Services'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Service</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>

                  <div className="row">

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >English Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >German Title<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='de_title' id="val-username" placeholder="" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='price' id="val-number" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-number" className="form-label">Month Price <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='per_month' id="val-number" />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">English Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">German Description <span className="text-danger">*</span></label>
                      <textarea rows="2" id="val-suggestions" className="form-control" name='de_description'></textarea>
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label className="form-label" htmlFor="val-suggestions">Image <span className="text-danger">*</span></label>
                      <img className="img-drop-area" src={file} height={file? 100:0} width={file?100:0}alt='' />
                      <input type="file" className="form-control" name='icon' accept="image/png, image/jpeg, image/svg+xml" id="val-number" onChange={onFileChange} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="exampleFormControlInput2" className="form-label"> Select Type <span className="text-danger">*</span></label>
                      <select className="form-control" name="type" >
                        <option value="0">Fixed</option>
                        <option value="1">Per Night</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <div className="col-xl-12 mb-3">
                      {error && <h5 style={{ color: 'red' }}>{error}</h5>}
                    </div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};
export default Services;